import { JobStatusOrCreating } from "@/types/job-status-or-creating";

export const jobStatusToChakraStatus = (status: JobStatusOrCreating) => {
  switch (status) {
    case "scheduled":
    case "pending":
    case "cancelling":
    case "creating":
      return "loading";
    case "completed":
      return "success";
    case "cancelled":
      return "warning";
    case "failed":
    case "crashed":
      return "error";
    case "running":
      return "inProgress";
    default:
      return "info";
  }
};
